export default __webpack_public_path__ + "static/media/casino-bg.17d97c49.png";